import { useState, useEffect } from "react";
import Resources from "scripts/resources";

function Component() {
	const [userLocation, setUserLocation] = useState(null);

	useEffect(() => {
		document.title = `${Resources.around} ${Resources.i}`;
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					setUserLocation([
						position.coords.latitude,
						position.coords.longitude,
					]);
				},
				(error) => {
					console.error(error);
				}
			);
		} else {
			console.error("Geolocation is not supported by this browser.");
		}
	}, []);

	return (
		<div>
			{userLocation ? (
				<p>
					Your location: {userLocation[0]}, {userLocation[1]}
				</p>
			) : (
				<p>Loading your location...</p>
			)}
		</div>
	);
}

export default Component;
